
import * as types from '../mutation-types';
import { get_hotels, search_place } from '@/api/location';

export const state = {
    hotel: [],
    restaurant: [],
    search_hotel: [],
    placeSelected: {},
    meta: {},
    loading: false,
    search_loading: false,
    filters: {},
    seletedFilters : {
        cuisines: {},
        meal: {} 
    }

}
export const getters = {
    hotel: state => state.hotel,
    restaurant: state => state.restaurant,
    placeSelected: state => state.placeSelected,
    loading: state => state.loading,
    meta: state => state.meta,
    search_hotel: state => state.search_hotel,
    search_loading: state => state.search_loading,
    filters: state => state.filters,
    seletedFilters: state => state.seletedFilters,
}
export const mutations = {
    [types.HOTEL](state, payload) {
        state.loading = true; 
    },
    [types.HOTEL_FAIL](state, payload) {
        state.loading = false;
        state.hotel = [];
    },
    [types.HOTEL_SUCCESS](state, payload) {
        state.loading = false;
        state.hotel = payload.main_location;
        state.filters ={
            meals: payload.meals,
            cuisines: payload.cuisines
        }
        state.meta = payload.meta;
    },
    [types.SELECTED_LOCATION](state, payload) {
        state.placeSelected = payload;
    },
    [types.SEARCH_SUGGUESTION](state, payload) {
        state.search_loading = true;
    },
    [types.SEARCH_SUGGUESTION_FAIL](state, payload) {
        state.search_loading = false;
        state.search_hotel = [];
    },
    [types.SEARCH_SUGGUESTION_SUCCESS](state, payload) {
        state.search_loading = false;

        if (payload.items) {
            state.search_hotel = payload.items;
        } else {
            state.search_hotel = []
        }

    },
    updateFilters(state, payload){
        state.seletedFilters = payload
    }
}
export const actions = {

    updateFilter({ commit, getters }, payload){
         commit('updateFilters',payload );
    },

    async getHotels({ commit, getters }, payload) {
        commit(types.HOTEL);
        try {
            const data = await get_hotels(payload); 
            commit(types.HOTEL_SUCCESS, data);
        } catch (error) {
            commit(types.HOTEL_FAIL);
        }
    },
    async setLocation({ commit }, payload) {
        commit(types.SELECTED_LOCATION, payload);

    },
    async searchSuggestion({ commit, getters }, payload) {
        commit(types.SEARCH_SUGGUESTION);
        try {
            const data = await search_place(payload);
            commit(types.SEARCH_SUGGUESTION_SUCCESS, data);
        } catch (error) {
            commit(types.SEARCH_SUGGUESTION_FAIL);
        }
    },
    clearSearch({ commit, getters }, payload) {
        commit(types.SEARCH_SUGGUESTION_SUCCESS, []);
    }
}
